import type { Meilisearch_LieuEdition } from '@/lib/api/meilisearch-types';
import type { LieuxEdition } from '@/types/new-directus-types';

export const computeLieuPhoto = (
  lieu: LieuxEdition | Meilisearch_LieuEdition,
) => {
  if (lieu?.miniature_carree) return lieu.miniature_carree;

  return 'db1682b1-7784-4992-b9cc-3b9561784949';
};
